/**
 * @typedef {object} StatsLeadersState
 * @property {StatsLeadersNavState} nav
 * @property {StatsLeadersSortState} sort
 * @property {StatsLeadersFilterState} filters
 * @property {StatsLeadersBenchmarkingState} benchmarking
 * @property {StatsLeadersDataTypeState} dataType
 * @property {object} values
 * @property {object} values.stats
 * @property {object} values.players
 * @property {object} values.teams
 * @property {object} keys
 * @property {object} keys.seasons
 * @property {object} keys.rounds
 * @property {RequestDetails[]} requests
 */

/**
 * @typedef {object} StatsLeadersNavState
 * @property {number} playerCount
 * @property {string} category
 * @property {object} competition
 * @property {number|null} competition.id
 * @property {object} season
 * @property {number|null} season.id
 * @property {object} round
 * @property {number|null} round.id
 * @property {number|null} round.number
 */

/**
 * @typedef {object} StatsLeadersSortState
 * @property {string} columnId
 * @property {'ascending'|'descending'} sortDirection
 */

/**
 * @typedef {object} StatsLeadersFilterState
 * @property {string[]} positions
 * @property {string[]} teams
 */

/**
 * @typedef {object} StatsLeadersBenchmarkingState
 * @property {boolean} isActive
 */

/**
 * @typedef {object} StatsLeadersDataTypeState
 * @property {'totals'|'averages'|'benchmarkedTotals'|'benchmarkedAverages'} type
 */

/**
 * @typedef {object} SetStatsLeadersActions
 * @property {string} type
 * @property {any} payload
 */

/**
 * @typedef {object} RequestDetails
 * @property {string} id
 * @property {'rounds'|'seasons'} type
 * @property {boolean} benchmarking
 */